export default {
  moneySymbol: '¥',
  tableForm: {
    search: '検索',
    reset: 'リセット',
    submit: '提交',
    collapsed: '展開',
    expand: '収納',
    inputPlaceholder: '入力してください',
    selectPlaceholder: '選択してください',
  },
  alert: {
    clear: 'クリア',
    selected: '選択した',
    item: '項目',
  },
  pagination: {
    total: {
      range: '記事',
      total: '/合計',
      item: ' ',
    },
  },
  tableToolBar: {
    leftPin: '左に固定',
    rightPin: '右に固定',
    noPin: 'キャンセル',
    leftFixedTitle: '左に固定された項目',
    rightFixedTitle: '右に固定された項目',
    noFixedTitle: '固定されてない項目',
    reset: 'リセット',
    columnDisplay: '表示列',
    columnSetting: '列表示設定',
    fullScreen: 'フルスクリーン',
    exitFullScreen: '終了',
    reload: '更新',
    density: '行高',
    densityLarger: '默认',
    densityMiddle: '中',
    densitySmall: '小',
  },
};
